export default "__VITE_ASSET__DcXS98W8__"